export const isTakedaMode = !!process.env.VUE_APP_TAKEDA_MODE;
